/**
 * helper function to try and parse an int, returning
 * @param fromString The string to try and parse an int from.
 * @return either the string as a number or the original string.
 */
export function tryParseInt(fromString: string): number | string {
  try {
    const parsed = parseInt(fromString);
    if (isNaN(parsed)) {
      console.warn(`Expected ${fromString} to be an int but it was NaN`);
      return fromString;
    }
    return parsed;
  } catch (e) {
    console.error(e);
    return fromString;
  }
}
